<template>
    <v-card class="elevation-10">
        <v-card-title>

        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="items.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props">
                <tr>
                    <td class="text-xs" >{{ props.item.name }}</td>
                    <td class="layout px-0 align-center">
                        <v-btn flat icon :to="{ name: 'admin.notifications.edit', params: { id: props.item.id }}"><v-icon>edit</v-icon></v-btn>
                    </td>
                </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
    </v-card>
</template>

<script>
    import { BASE } from '../../../../config';

    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'number_order'
                    },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                items: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                BASE: BASE
            }
        },
        created: function() {
            this.setSectionTitle();
            this.getItems();
            this.debouncedGetItems = _.debounce(this.getItems, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetItems();
            },
        },
        methods : {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Notifications'
                });
            },
            getItems () {
                this.$store.dispatch('getNotifications', {}).then((res) => {

                    this.items = res.data;
                    this.loading = false;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/config/notifications/IndexComponent.vue